module.exports = __webpack_public_path__ + "img/2.6d6d6927.png";